import { ACTION_TYPES } from "./constants";

export const setSlippage = (payload: string) => ({
  type: ACTION_TYPES.SET_SLIPPAGE_AMOUNT,
  payload,
});
